export default __webpack_public_path__ + "static/media/noteAndNotify.11790ad1.svg";